(ns frontend.view.grid.lp-reports-grid.event
  (:require
   [ajax.core :as ajax]
   [common.localization :as loc]
   [frontend.local-storage :as ls]
   [frontend.routing :as routing]
   [frontend.view.grid.lp-reports-grid.sub :as sub]
   [frontend.view.modals.curtains.column-selector-curtain.view :as column-selector-curtain]
   [frontend.view.modals.events :as modals]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(rf/reg-event-fx
 ::reload-ok
 (fn [{db :db} [_ resp]]
   {:db (-> db
            (assoc-in [::sub/reports] (:body resp))
            (assoc-in [::sub/loading?] false))}))

(rf/reg-event-fx
 ::reload-failed
 (fn [{db :db} [_ resp]]
   (js/console.log "FAILED " resp)
   {:db (-> db
            (assoc-in [::sub/loading?] false))}))

(rf/reg-event-fx
 ::reload
 (fn [{db :db} [_ all-columns]]
   (let [selected-columns (or (ls/get-in [::sub/selected-columns])
                              (->> all-columns
                                   (map :column/key)
                                   (remove (fn [k]
                                             (some #{k}
                                                   [:row-id
                                                    :fund/name
                                                    :common/created-on
                                                    :lp-report/step
                                                    :lp-report-holding/template-type
                                                    :lp-report/template-type]
                                                   )))
                                   (set)))]
     {:db         (-> db
                      (assoc ::sub/loading? true)
                      (assoc ::sub/selected-columns selected-columns))
      :http-xhrio {:method          :post
                   :uri             "/lp-reporting/api/search"
                   :params          {:filters {:entity/type :entity.type/lp-report
                                               :lp-report/text-status
                                               :lp-report.publishing-status/wip}}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::reload-ok]
                   :on-failure      [::reload-failed]}})))

(rf/reg-event-fx
 ::unload
 (fn [{db :db} _]
   {:db (-> db
            (potpuri/dissoc-in [::sub/reports]))}))

(rf/reg-event-fx
 ::open-report
 (fn [{_db :db} [_ {:keys [fund-id report-id]}]]
   (routing/set-view! [:lp-portal/report-editor :fund-id fund-id :id report-id])
   {}))

(rf/reg-event-fx
 ::set-visible-columns
 (fn [{db :db} [_ selected-columns]]
   (ls/set ::sub/selected-columns selected-columns)
   {:db (assoc-in db [::sub/selected-columns] selected-columns)}))

(rf/reg-event-fx
 ::open-columns-selector
 (fn [{db :db} [_ all-columns _]]
   (let [selected-columns (get-in db [::sub/selected-columns])
         temp-state (r/atom (set selected-columns))]
     (modals/open-modal!
      column-selector-curtain/modal-key
      {:header-text      (loc/tr :curtain-select-columns/header)
       :values-row-width 3
       :label-row-width  9
       :options          {true  [:span.label-sm (loc/tr :column/selected)]
                          false [:span.label-sm (loc/tr :column/not-selected)]}
       :state            temp-state
       :column-tabs      []
       :resolve-tab      identity
       :fields-getter    (fn [_]
                           (->> all-columns
                                (mapv (fn [col]
                                        (let [k (:column/key col)]
                                          {:field/name  (:column/label col)
                                           :field/value (boolean (some #{k} @temp-state))
                                           :field/key   k})))))
       :on-change!       (fn [k v]
                           (if v
                             (swap! temp-state conj k)
                             (swap! temp-state disj k)))
       :on-save!         (fn [_]
                           (rf/dispatch [::set-visible-columns @temp-state]))}))))
